
namespace GeniuzPOS.PosShift {

    @Serenity.Decorators.registerClass()
    export class PaymentTypeDialog extends Serenity.EntityDialog<PaymentTypeRow, any> {
        protected getFormKey() { return PaymentTypeForm.formKey; }
        protected getIdProperty() { return PaymentTypeRow.idProperty; }
        protected getLocalTextPrefix() { return PaymentTypeRow.localTextPrefix; }
        protected getNameProperty() { return PaymentTypeRow.nameProperty; }
        protected getService() { return PaymentTypeService.baseUrl; }
        protected getDeletePermission() { return PaymentTypeRow.deletePermission; }
        protected getInsertPermission() { return PaymentTypeRow.insertPermission; }
        protected getUpdatePermission() { return PaymentTypeRow.updatePermission; }

        protected form = new PaymentTypeForm(this.idPrefix);

    }
}